import { styled } from '@mui/material/styles';

export const StyledGroupedUnorderedList = styled('ul')`
    padding: 0;
    margin: 0;
    list-style: none;
`;
